require('../changeEmailService');
require('../../fhApp/currentUser/currentUser');

angular.module('app.changeEmail.changeEmailVerifyController', [
  'app.changeEmail.changeEmailService',
  'app.currentUser'
])
  .controller('app.changeEmail.changeEmailVerifyController', [
    '$scope',
    '$stateParams',
    'app.changeEmail.changeEmailService',
    '$state',
    'currentUser',
    function ($scope, $stateParams, changeEmailService, $state, currentUser) {
      "use strict";

      $scope.old_email = null;
      $scope.new_email = null;
      $scope.current_password = null;
      $scope.error = null;

      let init = () => {
        changeEmailService.getFromHash($stateParams.hash)
          .then((response) => {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }

            if (data.email) {
              $scope.new_email = data.email;
            }
          });
      };

      $scope.submitRequest = () => {
        changeEmailService.confirmChange(
          $stateParams.hash,
          $scope.old_email,
          $scope.current_password,
          $scope.new_email
        )
          .then((response) => {
            let data = response.data;

            if (data.error) {
              $scope.error = data.error;
            }

            if (data.email) {
              currentUser.logout();
              $state.go('app.login', {
                autoLogin: true,
                login_name: data.email,
                password: $scope.current_password,
                redirect: 'app.home'
              });
            }
          });
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/changeEmail/changeEmailVerify/changeEmailVerifyController.js